import React, { useEffect } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid2 } from '@mui/material'
import { useForm } from 'react-hook-form';
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from 'zod';

import ControlledTextField from '@components/inputs/controlledTextField';
import CustomButton from '@components/button/customButton';

const schema = z.object({
  remark: z.string().min(1, { message: 'Remark is required' })
});

export default function RemarkDialog({open, onClose, dialogTitle = "Void", loading = false, onSubmit }) {

  const { handleSubmit, control, reset } = useForm({
    resolver: zodResolver(schema),
  });

  const onRemarkSubmit = (data) => {
    onSubmit(data)
  };

  const handleClose = () => {
    if(!loading)
      onClose()
  }

  useEffect(()=>{
    if(!open)
      reset()
  },[open])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ '& .MuiDialog-paper': { borderRadius: '10px' } }}
      fullWidth
    >
      <DialogTitle id="alert-dialog-title" fontSize={"0.9rem"} fontWeight={600} color='#202020' sx={{padding: '20px 25px'}}>
        {dialogTitle}
      </DialogTitle>
      <DialogContent sx={{padding: '0px 25px', overflow: 'visible'}}>
        <Grid2 container spacing={"20px"}>
          <Grid2 size={12}>
            <ControlledTextField
              name="remark"
              label={"Enter Remark"}
              control={control}
              multiline
              rows={3}
              disabled={loading}
            />
          </Grid2>
        </Grid2>
      </DialogContent>
      <DialogActions sx={{padding: '20px 25px'}}>
        <CustomButton color='#999999' onClick={handleClose} disabled={loading}>
          Cancel
        </CustomButton>
        <CustomButton onClick={handleSubmit(onRemarkSubmit)} loading={loading}>
          Confirm
        </CustomButton>
      </DialogActions>
    </Dialog>
  )
}